import React, { useState, useEffect } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { ApiCall, Colors } from "../../../common/Const";
import TextBox from "../TextBox";
import { toast, ToastContainer } from "react-toastify";

function Subscribe(props) {
  const { windowSize, reviewData } = props;
  const [email, inputChange] = useState("");
  const [loading, setLoading] = useState(false);
  const loginValidation = () => {
    let isValid = true;
    if (email == "") {
      console.log("emal");
      isValid = false;

      toast.error("Enter your email", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      // console.log("emal else")
      // setemailError("");
      // isValid = true;
    }
    if (email != "") {
      let lastAtPos = email.lastIndexOf("@");
      let lastDotPos = email.lastIndexOf(".");
      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          email.indexOf("@@") == -1 &&
          lastDotPos > 2
        )
      ) {
        isValid = false;
        // setemailError("Enter valid Email");
        // console.log("email val")
        toast.error("Enter valid Email!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      // isValid = true;
      // setemailError("");
      // console.log("email val else")
    }

    return isValid;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!loginValidation()) {
    } else {
      setLoading(true);
      const enquryData = {
        email: email,
      };

      ApiCall("add_subscribe", enquryData)
        .then((data) => {
          console.log("response -->", data);
          setLoading(false);

          toast.success("Subscribed Successfully...!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          inputChange("");
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };
  return (
    <div
      className="container mt-4"
      style={{
        backgroundColor: Colors.Base_color,
        padding: 20,
        justifyItems: "center",
        marginBottom: 10,
        borderRadius: 20,
      }}
    >
      <h1
        style={{
          color: Colors.Secondary_color,
          textAlign: "center",
        }}
      >
        Subscribe to our Newsletter
      </h1>
      <p
        style={{
          color: "white",
          textAlign: "center",
        }}
      >
        Subscribe to get latest news and offers
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 20,
          justifyContent: "center",
          width: "100%",
        }}
      >
        <input
          type="text"
          placeholder="Enter your Email"
          className="input_sub"
          value={email}
          onChange={(e) => {
            inputChange(e.target.value);
          }}
        />
        <div
          style={{
            background: Colors.Secondary_color,
            padding: 10,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            borderRadius: 30,
            padding: " 10px 30px",

            cursor: "pointer",
          }}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          <p
            style={{
              margin: 0,
              color: "white",
              fontSize: 15,
            }}
          >
            {
                loading? 'Loading... ': 'Subscribe'
            }

          
          </p>
          {
            !loading && 
            <i
              class="fa-solid fa-arrow-right"
              style={{
                color: "white",
                fontSize: 15,
              }}
            ></i>
          }
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default Subscribe;
